import React from 'react';
import TestimonialCardInfo from 'components/TestimonialCardInfo';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
//import {Carousel} from 'react-responsive-carousel';
//import "react-responsive-carousel/lib/styles/carousel.min.css";

import abrilLogo from 'images/testimonial/Abril logo Testimonials_InFocus.jpg';
import kbsLogo from 'images/testimonial/KBS.png';
import RBDLogo from 'images/testimonial/RBD_Logo.png';
import DakwalLogo from 'images/testimonial/DAK-WAL.jpg';

import './TestimonialCard.css'
import TestimonialCardInfoSlick from 'components/TestimonialCardInfoSlick';

type TestimonialCardProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  logo: string,
  name: string,
  title: string,
  dcp: string,
  //card: any[]
}


const TestimonialCard = () => {
  const TestimonialCardLogo = {
    left: '<',
    right: '>'
  }

  
  const featureTestimonialCard = [
    {
      logo: abrilLogo, 
      name: 'E. Kuzman', 
      title:'General Manager, Abril Building Solutions', 
      dcp:'The simplicity and effectiveness of the system has allowed us to easily incorporate Video Assessments within our company. Our main focus was to ensure the system we implemented made it easy and convenient for our customers, and the system does this with the click of a button.'
    },
    {
      logo: kbsLogo, 
      name: 'J. Tauelangi', 
      title:'Project Co-ordinator, Administration', 
      dcp:'As a result of the COVID-19 pandemic, and the lockdown laws causing restrictions associated with site attendances, we felt it necessary to implement a video triage software that would assist us in completing property inspections when clients were not comfortable having others in their homes. After researching several companies that provided video triage software, we were pointed towards InFocus by a client. The team at InFocus, went above and beyond to assist with all our queries regarding the software, and an online demo was provided. As a builder, we were very impressed with the simplicity of the software and its functionality. At first, the implementation of the software was to enable our assessors to complete inspections without having to travel to site, however the software can be applied to many aspects of our building company and has enabled us to communicate at a different level with our trades onsite when issues have arisen. We would highly recommend InFocus for any company looking at this type of software'
    }

  ]

  const featureTestimonialCardSecond = [
    {
      logo: DakwalLogo,
      name: 'A. Golledge',
      title: 'Supplier Relationship Manager',
      dcp: 'The whole process (with InFocus) has been easy, quick and friendly. The product itself is easy to use, and very user friendly to the user and the customer.'
    },
    {
      logo: RBDLogo, 
      name: 'R. Doherty', 
      title: 'Director', 
      dcp: 'RBD Building & Maintenance were recently introduced to the ENData InFocus video platform. We have found the system to be of a great benefit in scenarios where complex situations occur  onsite and our trades require technical assistance. The quality of the video and audio provided is also of the highest quality. Urgent reports required by the insurer can be compiled between the estimator and our office and submitted to the insurer whilst the estimator is still on the road.'
    }
  ]

  const featureTestimonialCardTotal = [
    {
      logo: abrilLogo, 
      name: 'E. Kuzman', 
      title:'General Manager, Abril Building Solutions', 
      dcp:'The simplicity and effectiveness of the system has allowed us to easily incorporate Video Assessments within our company. Our main focus was to ensure the system we implemented made it easy and convenient for our customers, and the system does this with the click of a button.'
    },
    {
      logo: kbsLogo, 
      name: 'J. Tauelangi', 
      title:'Project Co-ordinator, Administration', 
      dcp:'As a result of the COVID-19 pandemic, and the lockdown laws causing restrictions associated with site attendances, we felt it necessary to implement a video triage software that would assist us in completing property inspections when clients were not comfortable having others in their homes. After researching several companies that provided video triage software, we were pointed towards InFocus by a client. The team at InFocus, went above and beyond to assist with all our queries regarding the software, and an online demo was provided. As a builder, we were very impressed with the simplicity of the software and its functionality. At first, the implementation of the software was to enable our assessors to complete inspections without having to travel to site, however the software can be applied to many aspects of our building company and has enabled us to communicate at a different level with our trades onsite when issues have arisen. We would highly recommend InFocus for any company looking at this type of software'
    },
    {
      logo: RBDLogo, 
      name: 'R. Doherty', 
      title: 'Director', 
      dcp: 'RBD Building & Maintenance were recently introduced to the ENData InFocus video platform. We have found the system to be of a great benefit in scenarios where complex situations occur  onsite and our trades require technical assistance. The quality of the video and audio provided is also of the highest quality. Urgent reports required by the insurer can be compiled between the estimator and our office and submitted to the insurer whilst the estimator is still on the road.'
    },
    {
      logo: DakwalLogo,
      name: 'A. Golledge',
      title: 'Supplier Relationship Manager',
      dcp: 'The whole process (with InFocus) has been easy, quick and friendly. The product itself is easy to use, and very user friendly to the user and the customer.'
    }
  ]

  const totalCard = [
    featureTestimonialCard,
    featureTestimonialCardSecond
  ]
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    adaptiveHeight: true,
    arrows: false,
  }
  
  return (
      <div className='' >
{/* 
        <div className='flex justify-center mt-auto mb-auto mx-3'
        >
          <div className='changeBgColor bg-gray-300 rounded-full h-10 w-10 text-white items-center justify-center flex'>
            {TestimonialCardLogo.left}
          </div>
        </div>
        {
          featureTestimonialCard.map((item, index)=>{
            return (
              <TestimonialCardInfo className="mx-3 flex-3 my-5" key={index} logo={item.logo} name={item.name} title={item.title} dcp={item.dcp}/>
            )
          })
        }
        <div className='flex mt-auto mb-auto mx-3'>
          <div className='changeBgColor bg-gray-300 rounded-full h-10 w-10 flex items-center justify-center text-white'>
            {TestimonialCardLogo.right}
          </div>
        </div> */}
        {/* <Carousel showIndicators = {true} showThumbs={false} showStatus={false} showArrows = {true} >
          {
            totalCard.map((item, index)=>{
              return (
                <TestimonialCardInfo className="mx-3 flex my-5 justify-center" 
                 key={index} card = {item}
                // logo={item.logo} name={item.name} title={item.title} dcp={item.dcp}
                />
              )
            })
          }
          
        </Carousel> */}
        
        <Slider {...settings} className='px-3 hidden md:flex lg:flex xl:flex'>
            {
              totalCard.map((item, index)=>{
                return (
                  <TestimonialCardInfo className="mx-3 flex my-5 justify-center" 
                  key={index} card = {item}
                  // logo={item.logo} name={item.name} title={item.title} dcp={item.dcp}
                  />
                )
              })
            }
        </Slider> 

        {/* phone vision */}
        <Slider {...settings} className='md:hidden'>
            {
              featureTestimonialCardTotal.map((item, index)=>{
                return (
                  <TestimonialCardInfoSlick className="" 
                  key={index}
                  logo={item.logo} name={item.name} title={item.title} dcp={item.dcp}
                  />
                )
              })
            }
        </Slider>

      </div>
  )
}


export default TestimonialCard;